import produce from "immer";
import {
    settingsActionNames,
    SettingsActionTypes,
} from "./settingsActionTypes";
import { SettingsState } from "./settingsState";

export const settingsReducer = (
    state: SettingsState,
    action: SettingsActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            /* Settings Fetch */
            case settingsActionNames.SETTINGS_FETCH: {
                draft.ui.isBusy = true;
                break;
            }

            case settingsActionNames.SETTINGS_FETCH_SUCCESS: {
                draft.ui.isBusy = false;
                draft.ui.error = undefined;
                draft.data.client = action.payload.client;
                break;
            }

            case settingsActionNames.SETTINGS_FETCH_FAILURE: {
                draft.ui.isBusy = false;
                draft.ui.error = action.payload.error;
                break;
            }

            /* Settings Save */
            case settingsActionNames.SETTINGS_SAVE: {
                draft.ui.isBusy = true;
                break;
            }

            case settingsActionNames.SETTINGS_SAVE_SUCCESS: {
                draft.ui.isBusy = false;
                draft.ui.error = undefined;
                break;
            }

            case settingsActionNames.SETTINGS_SAVE_FAILURE: {
                draft.ui.isBusy = false;
                draft.ui.error = action.payload.error;
                break;
            }

            /* Toggle Alerts */
            case settingsActionNames.SETTINGS_TOGGLE_ALERTS: {
                draft.ui.isBusy = true;
                break;
            }

            case settingsActionNames.SETTINGS_TOGGLE_ALERTS_SUCCESS: {
                draft.ui.isBusy = false;
                draft.ui.error = undefined;
                break;
            }

            case settingsActionNames.SETTINGS_TOGGLE_ALERTS_FAILURE: {
                draft.ui.isBusy = false;
                draft.ui.error = action.payload.error;
                break;
            }

            /* UI */
            case settingsActionNames.SET_CURRENT_TAB: {
                draft.ui.selectedTab = action.payload.tab;
                break;
            }

            case settingsActionNames.SET_CONTACT_CHANGED: {
                draft.ui.changed = action.payload.changed;
                break;
            }
        }
    });
